import {useHistory} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

export const PaymentSucceeded = () => {
  const history = useHistory()
  const redirectToDashboard = () => {
    history.push('/')
  }
  return (
    <div className='d-flex flex-column flex-root'>
      <div
        className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
        style={{backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/progress-hd.png')}')`}}
      >
        <div className='d-flex flex-column flex-column-fluid text-center p-10 py-lg-10'>
          {/* <a href='/dashboard' className='pt-lg-10'>
            <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-tmiv.png')} className='h-90px mb-5' />
          </a> */}
          <div className='pt-lg-10 mb-10'>
            <img src={toAbsoluteUrl('/media/illustrations/paid.png')} alt='' />
            <h1 className='fw-bolder fs-3x text-gray-700' style={{margin: '25px 0'}}>
              Thanh toán thành công
            </h1>
            <div className='fw-bold fs-3 text-gray-400' style={{width: '68%', margin: 'auto'}}>
              <p>
                Chúng tôi hiểu được rằng khi yêu cầu giải quyết quyền lợi bảo hiểm là lúc khách hàng
                cần đến sự hỗ trợ của chúng tôi hơn bao giờ hết. Cảm ơn đã tin tưởng và sử dụng
                TMIV.
              </p>
              <p>
                Thông tin giấy chứng nhận đã được gửi đến email của bạn. Vui lòng kiểm tra hộp thư
                đến.
              </p>
            </div>
            {/* <div className='text-center mt-10'>
              <a onClick={redirectToDashboard} className='btn btn-lg btn-primary fw-bolder'>
                Quay lại trang chủ
              </a>
            </div> */}
            {/* <Switch>
              <Route path='/error/404' exact={true}>
                <Error404 />
              </Route>
              <Route path='/error/500' exact={true}>
                <Error500 />
              </Route>
              <Redirect from='/error' exact={true} to='/error/404' />
              <Redirect to='/error/404' />
            </Switch>

            <div className='text-center'>
              <a onClick={redirectToDashboard} className='btn btn-lg btn-primary fw-bolder'>
                Quay lại trang chủ
              </a>
            </div> */}
          </div>
          {/* <div
            className='
          d-flex
          flex-row-auto
          bgi-no-repeat
          bgi-position-x-center
          bgi-size-contain
          bgi-position-y-bottom
          min-h-100px min-h-lg-350px
        '
            style={{
              backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/sketchy-1/17.png')}')`,
            }}
          ></div> */}
        </div>

        {/* <div className='d-flex flex-center flex-column-auto p-10'>
          <div className='d-flex align-items-center fw-bold fs-6'>
            <a href='https://keenthemes.com' className='text-muted text-hover-primary px-2'>
              About
            </a>
            <a href='mailto:support@keenthemes.com' className='text-muted text-hover-primary px-2'>
              Contact
            </a>
            <a href='https://1.envato.market/EA4JP' className='text-muted text-hover-primary px-2'>
              Contact Us
            </a>
          </div>
        </div> */}
      </div>
    </div>
  )
}
